import React, { useState, useEffect } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import { useCoolfoodContext } from './Store';

const useStyles = makeStyles(theme => {
  return {
    root: {
      display: 'flex',
      justifyContent: 'center',
      marginTop: theme.spacing(8),
      alignItems: 'center',
    },
    dot: {
      width: 16,
      height: 16,
      backgroundColor: theme.blue,
      borderRadius: '50%',
      marginRight: theme.spacing(1),
      '&:last-child': {
        marginRight: 0,
      }
    },
    disabled: {
      backgroundColor: '#d0d0d0'
    }
  };
});

export default function ProgressIndicator() {
  const [globalState] = useCoolfoodContext();
  const [dots, setDots] = useState(0);
  const classes = useStyles();

  useEffect(() => {
    const els = [];
    const staticSteps = (window._uuid) ? 3 : 4;
    let numOfSteps = staticSteps + globalState.selectedCommitments.length;
    for (let i = 0; i < numOfSteps; i++) {
      const disabled = i > globalState.currentSlide ? classes.disabled : '';
      els.push(<div key={i} className={`${classes.dot} ${disabled}`} />);
    }
    setDots(els);
  }, [
    classes.disabled,
    classes.dot,
    globalState.currentSlide,
    globalState.selectedCommitments.length
  ]);

  return <div className={classes.root}>{dots}</div>;
}
